import React from 'react'; 
import './share.css'
import '../fonts.css'
import URL from '../images/url.png'
import Email from '../images/email.png'
import Facebk from '../images/facebk.png'
import Linked from '../images/Link.png'
import Close from '../images/close.png'
import { useEffect, useState } from 'react';


export default function MobileShare({theme, menuOpen, setMenuOpen, sparklingTheme}) {

    const [isVisible, setIsVisible] = useState(false);
    useEffect(() => {
        if (menuOpen) {
          // Trigger fade-in shortly after mount
          const timeout = setTimeout(() => setIsVisible(true), 10); // 10ms lets the DOM paint first
          return () => clearTimeout(timeout);
        } else {
          setIsVisible(false); // triggers fade-out
        }
      }, [menuOpen]);

    const handleCopyUrl = async () => {
        try {
          await navigator.clipboard.writeText(window.location.href);
          alert('URL copied to clipboard!');
        } catch (err) {
          console.error('Failed to copy: ', err);
          alert('Failed to copy URL');
        }
    }

    const handleEmail = () => {
        const subject = encodeURIComponent('My Tasting Profile');
        const body = encodeURIComponent(`Check out my tasting profile here: ${window.location.href}`);
        const mailtoLink = `mailto:?subject=${subject}&body=${body}`;
    
        window.location.href = mailtoLink;
    };

    
    const handleFacebook = () => {
          const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`;
          window.open(shareUrl, '_blank', 'noopener,noreferrer');
    };

    const handleLinkedin = () => {
        const shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(window.location.href)}`;
        window.open(shareUrl, '_blank', 'noopener,noreferrer');
      };
    
      const highlight = {1: '#F8EBA9', 2: '#860000', 3: '#FFC9C1', 4: '#FFC9C1', 5: '#F8EBA9', 6: '#FBBD14'}
    
  return (
    <div className={`share-container ${menuOpen ? 'visible' : 'hidden'}`}>
        <div className='sub-container'>
            <button className='url' onClick={handleCopyUrl}>
                <div className='option'>
                    <img src={URL} className='url-img'></img>
                    <p className='menu-label'>Copy Link</p>
                </div>
            </button>
            <button className='email' onClick={handleEmail}>
                <div className='option'>
                    <img src={Email} className='email-image'></img>
                    <p className='menu-label'>E-mail</p>
                </div>
            </button>
            <button className='fb' onClick={handleFacebook}>
                <div className='option'>
                    <img src={Facebk} className='fb-img'></img>
                    <p className='menu-label'>Facebook</p>
                </div>
            </button>
            <button className='linked' onClick={handleLinkedin}>
            <div className='option'>
                    <img src={Linked} className='url-img'></img>
                    <p className='menu-label'>LinkedIn</p>
                </div>
            </button>
            <div className='highlight' style={{ backgroundColor: theme !== undefined ? highlight[theme] : highlight[sparklingTheme] }}></div>
            <button className='close-btn' onClick={() => setMenuOpen(false)}>
                <div className='close-option'>
                    <img src={Close} className='close-img'></img>
                    <p className='close-label'>Close</p>
                </div>
            </button>
        </div>
    </div>
  )
}
